import type { CheckboxProps as MantineCheckboxProps } from '@mantine/core';
import { Checkbox as StyledCheckbox } from './Checkbox.styled';
import CheckIcon from '../../../Icons/designSystem/Check.svg?react';

export type CheckboxProps = Pick<
  MantineCheckboxProps,
  'className' | 'disabled' | 'checked' | 'onChange' | 'label'
>;

const Checkbox: React.FC<CheckboxProps> = ({
  className,
  disabled,
  checked,
  onChange,
  label,
}) => {
  return (
    <StyledCheckbox
      className={className}
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      // @ts-expect-error - icon is not a valid prop for MantineCheckbox but it works
      icon={CheckIcon}
      label={label}
    />
  );
};

export default Checkbox;
